import { IonSpinner } from "@ionic/react";
import React from "react";
import "./Loading.css";
import { LoadingContainer, Logo, Spinner, TextoCargando } from "./localstyle";
import LogoLoading from "./assets/LoadingLogo.png";

const Loading = ({ dataLoading, color,descripcion }) => {
  return (
    <React.Fragment>
      {dataLoading && (
        // <div className="ptur-fondo-loading">
        //   <span className={color}>
        //     <IonSpinner name="lines"/>
        //   </span>
        //   <span className={`${color} rb18m`}>{descripcion}</span>
        // </div>
        <LoadingContainer>
        <Logo src={LogoLoading} $texto={descripcion} alt="Logo" />
        <TextoCargando className={`rb18m`}>{descripcion}</TextoCargando>
        <Spinner $size={120} $delay={0} />
      </LoadingContainer>
      )}
    </React.Fragment>
  );
};

export default Loading;
